// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"gVyW9DJ","tooltipArrow":"_1R5_Hnf"};